import 'pepjs'
import React from 'react'
import ReactDOM from 'react-dom'
import './fonts.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { UiState } from './reducers/ui'
import { EventState } from './reducers/event'

ReactDOM.render(
  <React.StrictMode>
    <UiState>
      <EventState>
        <App />
      </EventState>
    </UiState>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
